import { FormControlLabel, Checkbox } from "@material-ui/core";
import React from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";

export function ShowAllOrgCustomersCheckbox() {
    const { showOrgCustomers, setShowOrgCustomers } = useAddOwnerFlow();

    return (
        <FormControlLabel
            control={
                <Checkbox
                    value={showOrgCustomers}
                    color="primary"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        event.preventDefault();
                        setShowOrgCustomers(event.target.checked);
                    }}
                />
            }
            label="Show All Organization Customers"
        />
    );
}
